export default "__VITE_ASSET__HNySCtlG__"